/**
 * CRMアクセス拒否ページ
 *
 * CRMロールを持たないユーザーがCRMルートにアクセスした際に表示される。
 *
 * @return {JSX.Element} アクセス拒否ページ
 */

import { Button } from "components/ui/Button";
import { ShieldOff } from "lucide-react";
import type React from "react";
import { Link } from "react-router-dom";

export const CrmAccessDeniedPage: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <ShieldOff className="w-16 h-16 text-base-content/30 mb-6" />
      <h1 className="text-2xl font-bold mb-3">
        CRM機能へのアクセス権がありません
      </h1>
      <p className="text-base-content/60 mb-6 max-w-md">
        この機能は営業・採用担当者向けに限定されています。
        <br />
        アクセスが必要な場合は、テナント管理者にCRM権限の付与を依頼してください。
      </p>
      <Button asChild>
        <Link to="/">ダッシュボードに戻る</Link>
      </Button>
    </div>
  );
};

export default CrmAccessDeniedPage;
